import React from 'react'
import styles from './HorizontalDivider.module.css';

const HorizontalDivider = () => {
	return (
		<div className={styles.hd}>&nbsp;</div>
	)
}

export default HorizontalDivider